import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Servicepagebanner from '../components/Servicepagebanner';

function Manpower_Sourcing() {
  return (
    <div>
      <Header/>
<Servicepagebanner/>
     <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <div className="col-lg-8 m-auto">
                <div className="service-main-content heading1">
                    <h2>Manpower Sourcing </h2>
                    <div className="space16"></div>
                    <p>We understand that in today’s fast-paced business world, finding the right talent at the right time is crucial for sustained growth. At JBY Talent Acquisition & Management Private Limited, our manpower sourcing solutions go beyond traditional recruitment. 
                    </p>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/service2/Manpower_Sourcing.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                 
                    <p>We focus on identifying, attracting, and onboarding top-tier professionals who are not only skilled but also culturally aligned with your organization’s mission and values. Our process includes extensive candidate screening, background verification, skills assessment, and behavioral evaluation to ensure only the most suitable candidates progress to the hiring stage.</p>
                   
                    <div className="space32"></div>
                  
                    <p>  With our pre-vetted talent pool, businesses save valuable time, reduce recruitment costs, and minimize the risk of mismatched hires. Whether it’s entry-level positions, niche technical roles, or senior leadership placements, our sourcing strategy is designed to match talent that can seamlessly integrate into your team and contribute from day one.
                    </p>
                   
                    <div className="space32"></div>
                   
                    <div className="space32"></div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

      <Footer/>
    </div>
  )
}

export default Manpower_Sourcing
